/** Compares 2 objects (deep compare). */
export function isEqual<T>(a: T | undefined, b: T | undefined): boolean {
  if (a === undefined && b === undefined) return true
  if (a === undefined || b === undefined) return false
  if (a === null && b === null) return true
  if (a === null || b === null) return false
  if (Object.keys(a).length !== Object.keys(b).length) return false
  return typeof a === 'object' ? Object.entries(a).every(([key, val]) => isEqual(b[key as keyof T], val)) : a === b
}

export function isNotEqual<T>(a: T | undefined, b: T | undefined): boolean {
  return !isEqual(a, b)
}
